import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import featuredPostsInit from './redux/featuredPostsInit';

export const getFeaturedPostsWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  initActionsCreator: featuredPostsInit,
});
